/**
 * OAuth2 토큰 교환 관련 공통 유틸리티
 */ function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { OAUTH_ENDPOINTS, OAUTH_CLIENTS } from '@edusense/shared-constants';
// 중복 처리 방지를 위한 전역 상태
var ongoingExchanges = new Map();
/**
 * 토큰 교환 및 사용자 정보 획득을 처리하는 공통 함수
 */ export function exchangeTokenAndFetchUserInfo(params, config) {
    return _exchangeTokenAndFetchUserInfo.apply(this, arguments);
}
function _exchangeTokenAndFetchUserInfo() {
    _exchangeTokenAndFetchUserInfo = _async_to_generator(function(params, config) {
        var _userInfoRequestHeaders_Authorization, _config_USE_PROXY, USE_PROXY, AUTH_SERVER_URL, targetTokenUrl, USERINFO_ENDPOINT, tokenResponse, errorData, tokenData, actualTokenData, errorData1, access_token, refresh_token, id_token, expires_in, token_type, authorizationHeader, userInfoRequestHeaders, headerValidation, userInfoResponse, errorText, responseHeaders, tokenStructureCheck, userInfo, parts, payloadJson, user;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    // 기본 설정
                    USE_PROXY = (_config_USE_PROXY = config === null || config === void 0 ? void 0 : config.USE_PROXY) !== null && _config_USE_PROXY !== void 0 ? _config_USE_PROXY : true;
                    AUTH_SERVER_URL = (config === null || config === void 0 ? void 0 : config.AUTH_SERVER_URL) || 'https://auth.ugot.uk';
                    // 중요: 프록시 토큰 엔드포인트는 항상 auth.ugot.uk를 사용해야 함
                    // API_SERVER_URL이 아닌 AUTH_SERVER_URL을 사용
                    targetTokenUrl = USE_PROXY ? OAUTH_ENDPOINTS.proxyToken : OAUTH_ENDPOINTS.token;
                    USERINFO_ENDPOINT = OAUTH_ENDPOINTS.userinfo;
                    console.log('[TokenExchange] Calling token endpoint:', targetTokenUrl);
                    return [
                        4,
                        fetch(targetTokenUrl, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded'
                            },
                            body: params.toString()
                        })
                    ];
                case 1:
                    tokenResponse = _state.sent();
                    if (!!tokenResponse.ok) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        tokenResponse.text()
                    ];
                case 2:
                    errorData = _state.sent();
                    console.error('[TokenExchange] Token exchange failed:', errorData);
                    throw new Error('토큰 교환 실패');
                case 3:
                    return [
                        4,
                        tokenResponse.json()
                    ];
                case 4:
                    tokenData = _state.sent();
                    // Jackson 배열 형태 응답 처리
                    actualTokenData = tokenData;
                    if (Array.isArray(tokenData) && tokenData.length === 2 && tokenData[0] === "java.util.LinkedHashMap") {
                        console.log('[TokenExchange] Detected Jackson array format, extracting actual data');
                        actualTokenData = tokenData[1];
                    }
                    // 오류 응답 처리
                    if (actualTokenData && (typeof actualTokenData === "undefined" ? "undefined" : _type_of(actualTokenData)) === 'object' && 'error' in actualTokenData) {
                        console.error('[TokenExchange] Token endpoint returned an error:', actualTokenData);
                        errorData1 = actualTokenData;
                        if (errorData1.error === 'invalid_grant') {
                            throw new Error('토큰 교환 실패: 사용되었거나 유효하지 않은 인가 코드입니다.');
                        }
                        throw new Error("토큰 교환 실패: ".concat(errorData1.error, " - ").concat(errorData1.error_description || 'Unknown error'));
                    }
                    access_token = actualTokenData.access_token, refresh_token = actualTokenData.refresh_token, id_token = actualTokenData.id_token, expires_in = actualTokenData.expires_in, token_type = actualTokenData.token_type;
                    if (!access_token) {
                        throw new Error('토큰 응답에 액세스 토큰이 없습니다');
                    }
                    console.log('[TokenExchange] Token exchange successful:', {
                        access_token: access_token.substring(0, 50) + '...',
                        token_type: token_type,
                        expires_in: expires_in,
                        has_refresh_token: !!refresh_token,
                        refresh_token_length: refresh_token ? refresh_token.length : 0,
                        has_id_token: !!id_token,
                        id_token_length: id_token ? id_token.length : 0
                    });
                    // 🔍 DEBUG: Log full token response to understand what server sent
                    console.log('[TokenExchange] 🔍 FULL TOKEN RESPONSE FROM SERVER:', {
                        hasAccessToken: !!access_token,
                        hasRefreshToken: !!refresh_token,
                        refreshToken: refresh_token ? 'PRESENT' : 'MISSING',
                        hasIdToken: !!id_token,
                        scopes: actualTokenData.scope || 'no scope in response',
                        tokenType: token_type || 'Bearer',
                        expiresIn: expires_in
                    });
                    // 2. UserInfo 요청 (OAuth2 표준 방식)
                    console.log('[TokenExchange] Fetching user info...');
                    console.log('[TokenExchange] UserInfo endpoint:', USERINFO_ENDPOINT);
                    // 🔍 중요: 토큰이 실제로 유효한지 확인
                    if (!access_token || access_token.length < 10) {
                        console.error('[TokenExchange] ❌ Invalid access_token:', {
                            hasToken: !!access_token,
                            tokenLength: (access_token === null || access_token === void 0 ? void 0 : access_token.length) || 0,
                            tokenPrefix: (access_token === null || access_token === void 0 ? void 0 : access_token.substring(0, 10)) || 'null'
                        });
                        throw new Error('유효하지 않은 액세스 토큰입니다');
                    }
                    authorizationHeader = "Bearer ".concat(access_token);
                    userInfoRequestHeaders = {
                        'Accept': 'application/json',
                        'Authorization': authorizationHeader
                    };
                    console.log('[TokenExchange] 🔍 Request details:');
                    console.log('[TokenExchange]   - Method: GET');
                    console.log('[TokenExchange]   - URL:', USERINFO_ENDPOINT);
                    console.log('[TokenExchange]   - Authorization header:', "Bearer ".concat(access_token.substring(0, 20), "..."));
                    console.log('[TokenExchange]   - Full access_token length:', access_token.length);
                    console.log('[TokenExchange]   - Headers object:', JSON.stringify(userInfoRequestHeaders, null, 2));
                    console.log('[TokenExchange]   - Credentials:', 'omit');
                    // 🚨 실제 HTTP 요청 전에 헤더 검증
                    headerValidation = {
                        hasAcceptHeader: 'Accept' in userInfoRequestHeaders,
                        hasAuthorizationHeader: 'Authorization' in userInfoRequestHeaders,
                        authHeaderValue: userInfoRequestHeaders['Authorization'],
                        authHeaderLength: ((_userInfoRequestHeaders_Authorization = userInfoRequestHeaders['Authorization']) === null || _userInfoRequestHeaders_Authorization === void 0 ? void 0 : _userInfoRequestHeaders_Authorization.length) || 0
                    };
                    console.log('[TokenExchange] 🔍 Header validation:', headerValidation);
                    // 요청 직전 최종 확인
                    console.log('[TokenExchange] 🚀 About to send userinfo request...');
                    return [
                        4,
                        fetch(USERINFO_ENDPOINT, {
                            method: 'GET',
                            headers: userInfoRequestHeaders
                        })
                    ];
                case 5:
                    userInfoResponse = _state.sent();
                    if (!!userInfoResponse.ok) return [
                        3,
                        7
                    ];
                    return [
                        4,
                        userInfoResponse.text()
                    ];
                case 6:
                    errorText = _state.sent();
                    console.error('[TokenExchange] ❌ UserInfo request failed:');
                    console.error('[TokenExchange]   - Status:', userInfoResponse.status);
                    console.error('[TokenExchange]   - Status Text:', userInfoResponse.statusText);
                    console.error('[TokenExchange]   - Response Body:', errorText);
                    console.error('[TokenExchange]   - Request URL:', USERINFO_ENDPOINT);
                    console.error('[TokenExchange]   - Authorization header sent:', "Bearer ".concat(access_token.substring(0, 20), "..."));
                    // Response Headers 로깅 (서버에서 어떤 헤더를 보냈는지 확인)
                    responseHeaders = {};
                    userInfoResponse.headers.forEach(function(value, key) {
                        responseHeaders[key] = value;
                    });
                    console.error('[TokenExchange]   - Response Headers:', responseHeaders);
                    // 403 에러인 경우 특별히 분석
                    if (userInfoResponse.status === 403) {
                        console.error('[TokenExchange] 🔍 403 Forbidden Analysis:');
                        console.error('[TokenExchange]   - This indicates the server received the request but denied access');
                        console.error('[TokenExchange]   - Possible causes:');
                        console.error('[TokenExchange]     1. Invalid or expired access token');
                        console.error('[TokenExchange]     2. Missing Authorization header (even though we set it)');
                        console.error('[TokenExchange]     3. Server authentication filter configuration issue');
                        console.error('[TokenExchange]     4. Scope or permission issue');
                        // 토큰이 실제로 Bearer 형태인지 확인
                        tokenStructureCheck = {
                            startsWithBearer: authorizationHeader.startsWith('Bearer '),
                            tokenAfterBearer: authorizationHeader.substring(7, 27) + '...',
                            totalLength: authorizationHeader.length
                        };
                        console.error('[TokenExchange]   - Token structure check:', tokenStructureCheck);
                    }
                    throw new Error("사용자 정보 조회 실패: ".concat(userInfoResponse.status, " ").concat(userInfoResponse.statusText));
                case 7:
                    return [
                        4,
                        userInfoResponse.json()
                    ];
                case 8:
                    userInfo = _state.sent();
                    // 보강: 서버 userinfo에 picture가 없을 경우 id_token 클레임에서 보완 시도
                    try {
                        if ((!userInfo || !userInfo.picture) && id_token && typeof id_token === 'string') {
                            parts = id_token.split('.');
                            if (parts.length >= 2) {
                                payloadJson = JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')));
                                if (payloadJson && typeof payloadJson.picture === 'string' && payloadJson.picture.trim() !== '') {
                                    userInfo.picture = payloadJson.picture;
                                }
                                // 여유: 다른 기본 필드도 누락 시 보강
                                if (!userInfo.preferred_username && typeof payloadJson.preferred_username === 'string') {
                                    userInfo.preferred_username = payloadJson.preferred_username;
                                }
                                if (!userInfo.name && typeof payloadJson.name === 'string') {
                                    userInfo.name = payloadJson.name;
                                }
                                if (!userInfo.email && typeof payloadJson.email === 'string') {
                                    userInfo.email = payloadJson.email;
                                }
                            }
                        }
                    } catch (e) {
                        console.warn('[TokenExchange] ID 토큰에서 picture 보강 실패:', e === null || e === void 0 ? void 0 : e.message);
                    }
                    console.log('[TokenExchange] UserInfo received:', {
                        sub: userInfo.sub,
                        preferred_username: userInfo.preferred_username,
                        email: userInfo.email,
                        hasPicture: !!userInfo.picture
                    });
                    // 3. User 객체 생성
                    user = {
                        id: userInfo.sub,
                        username: userInfo.preferred_username || userInfo.email || userInfo.sub,
                        name: userInfo.name,
                        email: userInfo.email,
                        profileImage: userInfo.picture,
                        avatar: userInfo.picture
                    };
                    return [
                        2,
                        {
                            tokenData: actualTokenData,
                            userInfo: userInfo,
                            user: user
                        }
                    ];
            }
        });
    });
    return _exchangeTokenAndFetchUserInfo.apply(this, arguments);
}
/**
 * Authorization Code를 사용한 토큰 교환 (중복 처리 방지 포함)
 */ export function exchangeAuthorizationCode(code, codeVerifier, redirectUri) {
    return _exchangeAuthorizationCode.apply(this, arguments);
}
function _exchangeAuthorizationCode() {
    _exchangeAuthorizationCode = _async_to_generator(function(code, codeVerifier, redirectUri) {
        var clientId, config, exchangeKey, params, exchangePromise;
        var _arguments = arguments;
        return _ts_generator(this, function(_state) {
            clientId = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : OAUTH_CLIENTS.APP_CLIENT.clientId, config = _arguments.length > 4 ? _arguments[4] : void 0;
            // 🚨 중요: 전달받은 파라미터 값 상세 로깅
            console.log('[TokenExchange] 🔍 exchangeAuthorizationCode 호출됨:', {
                codeLength: (code === null || code === void 0 ? void 0 : code.length) || 0,
                codePrefix: (code === null || code === void 0 ? void 0 : code.substring(0, 20)) + '...',
                codeVerifierLength: (codeVerifier === null || codeVerifier === void 0 ? void 0 : codeVerifier.length) || 0,
                codeVerifierPrefix: (codeVerifier === null || codeVerifier === void 0 ? void 0 : codeVerifier.substring(0, 20)) + '...',
                redirectUri: redirectUri,
                clientId: clientId,
                configUseProxy: config === null || config === void 0 ? void 0 : config.USE_PROXY
            });
            // 목업 데이터 감지
            if (code === 'mock-auth-code-12345' || codeVerifier === 'test-verifier-12345') {
                console.error('[TokenExchange] 🚨 MOCK DATA DETECTED!');
                console.error('[TokenExchange] 🚨 실제 OAuth 플로우가 아닌 테스트 데이터가 전달됨:', {
                    code: code,
                    codeVerifier: codeVerifier
                });
            }
            // 중복 처리 방지: 동일한 코드로 진행 중인 교환이 있는지 확인
            exchangeKey = "".concat(code, "_").concat(clientId);
            if (ongoingExchanges.has(exchangeKey)) {
                console.log('[TokenExchange] Code exchange already in progress, waiting for existing operation');
                return [
                    2,
                    ongoingExchanges.get(exchangeKey)
                ];
            }
            params = new URLSearchParams({
                grant_type: 'authorization_code',
                code: code,
                redirect_uri: redirectUri,
                code_verifier: codeVerifier,
                client_id: clientId
            });
            console.log('[TokenExchange] 📤 Token exchange request params:', {
                grant_type: 'authorization_code',
                codeLength: code === null || code === void 0 ? void 0 : code.length,
                redirectUri: redirectUri,
                codeVerifierLength: codeVerifier === null || codeVerifier === void 0 ? void 0 : codeVerifier.length,
                clientId: clientId
            });
            // 진행 중인 교환 작업을 저장
            exchangePromise = exchangeTokenAndFetchUserInfo(params, config).finally(function() {
                // 완료 후 진행 중인 작업에서 제거
                ongoingExchanges.delete(exchangeKey);
            });
            ongoingExchanges.set(exchangeKey, exchangePromise);
            return [
                2,
                exchangePromise
            ];
        });
    });
    return _exchangeAuthorizationCode.apply(this, arguments);
}
